export const adminTours = {
  'admin-dashboard': {
    id: 'admin-dashboard',
    title: 'Admin Dashboard',
    category: 'admin',
    steps: [
      {
        target: '.admin-header',
        content: 'Welcome to the admin dashboard. Here you can manage all aspects of the system.',
        placement: 'bottom'
      },
      {
        target: '.dashboard-tabs',
        content: 'Switch between managing assignments and classes.',
        placement: 'bottom'
      },
      {
        target: '.admin-action-buttons',
        content: 'These buttons give you quick access to admin functions.',
        placement: 'bottom'
      },
      {
        target: '.enhanced-table',
        content: 'View and manage all assignments and classes in this table.',
        placement: 'top'
      }
    ],
    conditions: {
      userRole: 'admin',
      firstVisit: true,
      path: '/admin/dashboard'
    }
  },

  'admin-actions': {
    id: 'admin-actions',
    title: 'Admin Tools',
    category: 'admin',
    steps: [
      {
        target: '.create-user-btn',
        content: 'Add new users to your system with different roles and permissions.',
        placement: 'bottom'
      },
      {
        target: '.create-assignment-btn',
        content: 'Create new assignments for your clients with custom requirements.',
        placement: 'bottom'
      },
      {
        target: '.create-class-btn',
        content: 'Set up new classes and manage class schedules.',
        placement: 'bottom'
      },
      {
        target: '.comment-search-btn',
        content: 'Search through all comments and feedback across the system.',
        placement: 'bottom'
      },
      {
        target: '.discord-panel-btn',
        content: 'Manage your Discord server integration and settings.',
        placement: 'bottom'
      }
    ],
    conditions: {
      userRole: 'admin',
      elementVisible: '.admin-action-buttons',
      delay: 500
    }
  },

  'discord-integration': {
    id: 'discord-integration',
    title: 'Discord Integration',
    category: 'admin',
    steps: [
      {
        target: '.discord-connect-btn',
        content: 'Connect your Discord account for enhanced collaboration.',
        placement: 'bottom'
      },
      {
        target: '.server-selection',
        content: 'Choose which Discord server to integrate with the system.',
        placement: 'right'
      },
      {
        target: '.channel-mapping',
        content: 'Map Discord channels to your assignments and classes.',
        placement: 'right'
      },
      {
        target: '.notification-settings',
        content: 'Configure Discord notification preferences.',
        placement: 'left'
      },
      {
        target: '.sync-status',
        content: 'Monitor your Discord integration status here.',
        placement: 'top'
      }
    ],
    conditions: {
      elementVisible: '.discord-panel',
      delay: 500
    }
  },

  'user-management': {
    id: 'user-management',
    title: 'User Management',
    category: 'admin',
    steps: [
      {
        target: '.create-user-btn',
        content: 'Click here to create new users in the system.',
        placement: 'bottom'
      },
      {
        target: '.user-role-selector',
        content: 'Assign appropriate roles: admin, client, writer, or QA.',
        placement: 'right'
      },
      {
        target: '.user-permissions',
        content: 'Set specific permissions for each user role.',
        placement: 'right'
      },
      {
        target: '.user-status',
        content: 'Monitor user activity and status.',
        placement: 'left'
      }
    ],
    conditions: {
      userRole: 'admin',
      elementVisible: '.user-creation-form',
      delay: 500
    }
  },

  'assignment-management': {
    id: 'assignment-management',
    title: 'Assignment Management',
    category: 'admin',
    steps: [
      {
        target: '.create-assignment-btn',
        content: 'Create new assignments for clients.',
        placement: 'bottom'
      },
      {
        target: '.assignment-details',
        content: 'Fill in assignment requirements and deadlines.',
        placement: 'right'
      },
      {
        target: '.assign-writer',
        content: 'Assign writers to handle the assignment.',
        placement: 'right'
      },
      {
        target: '.quality-assurance',
        content: 'Set up quality assurance checks.',
        placement: 'left'
      },
      {
        target: '.assignment-status',
        content: 'Track assignment progress and status.',
        placement: 'top'
      }
    ],
    conditions: {
      userRole: 'admin',
      elementVisible: '.assignment-creation-form',
      delay: 500
    }
  }
};